'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  width: 400px;\n  margin: 0 auto;\n  background: white;\n  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.05), 0 2px 4px rgba(0, 0, 0, 0.2),\n    0 2px 6px rgba(0, 0, 0, 0.1);\n  font-size: small;\n  border: 1px solid #ddd;\n\n  input {\n    width: 100%;\n    padding: 5px;\n    font-size: 1em;\n    border: none;\n\n    &:focus {\n      outline: none;\n    }\n\n    &::placeholder {\n      color: #bababa;\n    }\n  }\n'], ['\n  width: 400px;\n  margin: 0 auto;\n  background: white;\n  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.05), 0 2px 4px rgba(0, 0, 0, 0.2),\n    0 2px 6px rgba(0, 0, 0, 0.1);\n  font-size: small;\n  border: 1px solid #ddd;\n\n  input {\n    width: 100%;\n    padding: 5px;\n    font-size: 1em;\n    border: none;\n\n    &:focus {\n      outline: none;\n    }\n\n    &::placeholder {\n      color: #bababa;\n    }\n  }\n']);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var StyledDiv = _styledComponents2.default.div(_templateObject);

exports.default = StyledDiv;


//////////////////
// WEBPACK FOOTER
// ./~/react-commander/lib/components/StyledDiv.js
// module id = 837
// module chunks = 107818501498521